/**
 * Extended HSInputNumber to fix floating-point precision issues
 *
 * This fixes the issue where incrementing by 0.1 causes values like 8.299999999
 * by properly rounding the result based on the number of decimal places in the step.
 */

console.log('Loading HSInputNumber extension...');

// Wait for HSInputNumber to be available
function patchHSInputNumber() {
    if (!window.HSInputNumber) {
        console.log('HSInputNumber not yet available, waiting...');
        setTimeout(patchHSInputNumber, 50);
        return;
    }

    console.log('HSInputNumber found, patching...');

    const OriginalHSInputNumber = window.HSInputNumber;

    // Store the original changeValue method
    const originalChangeValue = OriginalHSInputNumber.prototype.changeValue;

    /**
     * Get number of decimal places from a number
     */
    function getDecimalPlaces(num) {
        const match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        if (!match) return 0;
        return Math.max(
            0,
            (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0)
        );
    }

    /**
     * Round to specified decimal places
     */
    function roundToDecimals(value, decimals) {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    }

    /**
     * Patched changeValue method with floating-point fix
     */
    OriginalHSInputNumber.prototype.changeValue = function(mode) {
        const minInputValue = this.minInputValue ?? 0;
        const maxInputValue = this.maxInputValue ?? Infinity;
        const decimals = getDecimalPlaces(this.step);

        // Ensure inputValue is initialized - parse from input if null
        if (this.inputValue === null || this.inputValue === undefined || isNaN(this.inputValue)) {
            const inputVal = parseFloat(this.input?.value);
            this.inputValue = !isNaN(inputVal) ? inputVal : 0;
        }

        let payload = {
            inputValue: this.inputValue
        };

        switch (mode) {
            case 'increment':
                const incrementedResult = (this.inputValue ?? 0) + this.step;
                // Round to avoid floating-point precision errors
                const roundedIncrement = roundToDecimals(incrementedResult, decimals);
                this.inputValue =
                    roundedIncrement >= minInputValue && (maxInputValue === null || roundedIncrement <= maxInputValue)
                        ? roundedIncrement
                        : maxInputValue;
                if (this.input) this.input.value = (this.inputValue ?? 0).toString();
                break;

            case 'decrement':
                const decrementedResult = (this.inputValue ?? 0) - this.step;
                // Round to avoid floating-point precision errors
                const roundedDecrement = roundToDecimals(decrementedResult, decimals);
                this.inputValue =
                    roundedDecrement >= minInputValue && (maxInputValue === null || roundedDecrement <= maxInputValue)
                        ? roundedDecrement
                        : minInputValue;
                if (this.input) this.input.value = (this.inputValue ?? 0).toString();
                break;

            default:
                // For manual input, use parseFloat instead of parseInt to preserve decimals
                const defaultResult = isNaN(parseFloat(this.input?.value))
                    ? 0
                    : parseFloat(this.input.value);
                const roundedDefault = roundToDecimals(defaultResult, decimals);
                this.inputValue =
                    roundedDefault >= maxInputValue
                        ? maxInputValue
                        : roundedDefault <= minInputValue
                            ? minInputValue
                            : roundedDefault;
                if (this.inputValue <= minInputValue && this.input)
                    this.input.value = (this.inputValue ?? 0).toString();
                break;
        }

        payload.inputValue = this.inputValue;

        if (this.inputValue === minInputValue) {
            this.el.classList.add('disabled');
            if (this.decrement) this.disableButtons('decrement');
        } else {
            this.el.classList.remove('disabled');
            if (this.decrement) this.enableButtons('decrement');
        }

        if (this.inputValue === maxInputValue) {
            this.el.classList.add('disabled');
            if (this.increment) this.disableButtons('increment');
        } else {
            this.el.classList.remove('disabled');
            if (this.increment) this.enableButtons('increment');
        }

        this.fireEvent('change', payload);

        // Use dispatch from HSStaticMethods if available, otherwise use the old method
        if (window.HSStaticMethods && window.HSStaticMethods.dispatch) {
            window.HSStaticMethods.dispatch('change.inputNumber', this.el, payload);
        } else if (typeof dispatch !== 'undefined') {
            dispatch('change.inputNumber', this.el, payload);
        }
    };

    console.log('HSInputNumber patched successfully!');
}

// Start patching when the module loads
patchHSInputNumber();
